export default {
  authentication: {
    components: {
      forgottenPassword: {
        backButtonText: 'Retour'
      },
      login: {
        emailAccount: {
          backButtonText: 'Retour'
        }
      },
      registration: {
        contactPreferences: {
          skipButtonText: 'Passer cette étape'
        },
        createAccount: {
          backButtonText: 'Retour'
        }
      }
    },
    hooks: {
      useAccountLogin: {
        error: {
          submissionError: {
            message: 'Votre email et/ou mot de passe sont incorrects. Veuillez réessayer ou sélectionner Mot de passe oublié.'
          }
        }
      },
      useAuthPageProps: {
        landing: {
          heading: 'Créer un compte.',
          title: 'Créer un compte'
        },
        loginLanding: {
          heading: 'Se connecter.',
          title: 'Se connecter'
        },
        loginForm: {
          heading: 'Se connecter.',
          title: 'Se connecter'
        },
        loginVerifyAccount: {
          heading: 'Votre compte n\'est pas encore vérifié.',
          title: 'Vérification requise'
        },
        createAccount: {
          heading: 'Créer un compte.',
          title: 'Créer un compte'
        },
        resetPassword: {
          heading: 'Créer un nouveau mot de passe.',
          title: 'Créer un nouveau mot de passe'
        },
        changeEmailConfirmation: {
          heading: '_TODO: Enter your password.',
          title: '_TODO: Enter your password'
        },
        contactPreferences: {
          heading: 'Restez en contact.',
          title: 'Restez en contact'
        },
        forgottenPassword: {
          heading: 'Mot de passe oublié?',
          title: 'Mot de passe oublié?'
        },
        emailSentConfirmation: {
          verifyAccount: {
            heading: 'Vérifions votre compte.',
            title: 'Vérifiez votre compte'
          },
          resetPassword: {
            heading: 'Vérifiez votre boîte de réception.',
            title: 'Vérifiez votre boîte de réception'
          }
        },
        success: {
          "default": {
            heading: 'Vous êtes prêt à partir!',
            title: 'Vous êtes prêt à partir!'
          },
          accountAlreadyVerified: {
            heading: 'Votre compte est déjà vérifié.',
            title: 'Votre compte est déjà vérifié'
          },
          loginAccountVerified: {
            heading: 'Votre compte est maintenant vérifié.',
            title: 'Votre compte est maintenant vérifié'
          },
          resetPassword: {
            heading: 'Votre mot de passe a été changé.',
            title: 'Votre mot de passe a été changé'
          }
        },
        error: {
          "default": {
            heading: 'Créer un compte.',
            title: 'Quelque chose n\'a pas bien fonctionné'
          },
          errorWithRetrySignUp: {
            heading: 'Quelque chose n\'a pas bien fonctionné.',
            title: 'Quelque chose n\'a pas bien fonctionné'
          },
          errorWithResendEmail: {
            heading: 'Quelque chose a mal tourné de notre côté.',
            title: 'Quelque chose a mal tourné de notre côté'
          },
          linkExpiredWithResendEmail: {
            heading: 'Le lien de vérification a expiré.',
            title: 'Le lien de vérification a expiré'
          },
          loginGeneralError: {
            heading: 'Se connecter.',
            title: 'Quelque chose n\'a pas bien fonctionné'
          },
          loginVerificationErrorWithResendEmail: {
            heading: 'Quelque chose a mal tourné de notre côté.',
            title: 'Quelque chose a mal tourné de notre côté'
          },
          loginVerificationErrorWithRetry: {
            heading: 'Quelque chose n\'a pas bien fonctionné.',
            title: 'Quelque chose n\'a pas bien fonctionné'
          },
          loginVerificationLinkExpiredWithResendEmail: {
            heading: 'Le lien de vérification a expiré.',
            title: 'Le lien de vérification a expiré'
          },
          passwordResetTokenExpired: {
            heading: 'Le lien de réinitialisation du mot de passe a expiré.',
            title: 'Le lien de réinitialisation du mot de passe a expiré'
          }
        }
      },
      useAuthStatusProps: {
        success: {
          login: {
            accountVerified: {
              buttonText: 'Se connecter',
              heading: 'Succès!'
            }
          },
          registration: {
            buttonText: 'Ramenez-moi là où j\'ai commencé',
            buttonTextLogin: 'Cliquez ici pour vous connecter',
            heading: 'Succès!',
            subheading: 'Connecté en tant que:'
          },
          resetPassword: {
            buttonText: 'Connectez-vous à votre compte',
            loggedInButtonText: 'Terminé',
            contentPartOne: 'Vous pouvez changer votre mot de passe à tout moment en allant à vos',
            contentPartTwo: 'paramètres de compte'
          }
        },
        error: {
          login: {
            generalLoginError: {
              heading: '_TODO: Something didn\'t go quite right',
              subheading: '_TODO: Please try logging in again later',
              buttonText: '_TODO: Try again'
            },
            verificationErrorWithResendEmail: {
              buttonText: 'Renvoyer l\'email de vérification',
              content: 'Désolé pour ça! Essayez de cliquer ci-dessous pour envoyer un nouvel email de vérification.'
            },
            verificationErrorWithRetry: {
              buttonText: 'Réessayer',
              content: 'Nous avons rencontré un problème lors de la tentative de vérification de votre compte. Veuillez essayer de vous reconnecter et nous vous enverrons un nouvel email de vérification. Sinon, contactez le support à l\'adresse ci-dessous.'
            },
            verificationLinkExpiredWithResendEmail: {
              buttonText: 'Renvoyer l\'email de vérification',
              content: 'Le lien que nous vous avons envoyé n\'est plus valide, nous faisons cela pour sécuriser votre compte. Cliquez ci-dessous pour envoyer un nouvel email de vérification.'
            },
            verificationRequired: {
              buttonText: 'Renvoyer l\'email de vérification',
              content: 'Nous vous avons récemment envoyé un lien pour vérifier votre compte. Ceci est pour sécuriser votre compte. Ce lien a peut-être expiré, veuillez cliquer ci-dessous pour envoyer un nouveau lien.'
            }
          },
          registration: {
            buttonText: 'Réessayer',
            heading: 'Quelque chose n\'a pas bien fonctionné',
            subheading: 'Essayez de créer un compte à nouveau.'
          },
          resetPassword: {
            withRetry: {
              buttonText: 'Réessayer',
              content: 'Cliquez ci-dessous pour réessayer.'
            },
            withResendEmail: {
              buttonText: 'Renvoyer l\'email',
              content: 'Désolé pour ça! Essayez de cliquer ci-dessous pour envoyer un nouvel email de vérification.'
            },
            tokenExpired: {
              buttonText: 'Renvoyer l\'email',
              content: 'Le lien que nous vous avons envoyé n\'est plus valide, nous faisons cela pour sécuriser votre compte. Cliquez ci-dessous pour envoyer un nouvel email de mot de passe oublié.'
            }
          }
        }
      },
      useChangeEmailConfirmation: {
        error: {
          submissionError: {
            incorrectPassword: '_TODO: Your password is incorrect'
          }
        }
      },
      useStepperProps: {
        steps: {
          first: 'S\'inscrire',
          second: 'Préférences',
          third: 'Compléter'
        }
      }
    },
    toastNotifications: {
      success: {
        genericEmailReSent: 'L\'email a été renvoyé.',
        verificationEmailReSent: 'L\'email de vérification a été renvoyé.'
      },
      error: {
        verificationEmailFailed: 'Échec de l\'envoi de l\'email de vérification.'
      }
    }
  },
  myHub: {
    account: {
      header: '_TODO: My Account',
      details: {
        header: '_TODO: My Details',
        basicInformationSectionHeader: '_TODO: Basic information',
        accountManagementSectionHeader: '_TODO: Account management'
      }
    },
    collection: {
      calloutText: 'Enregistrez des éléments et créez des collections avec un compte gratuit',
      errorMessage: 'Impossible de charger les éléments suivants. Veuillez réessayer plus tard.',
      loadNext: 'Charger le suivant',
      // v4 plural
      taglineItem_one: 'article',
      taglineItem_few: 'articles',
      taglineItem_many: 'articles',
      taglineItem_other: 'articles',
      // v3 plural
      taglineItem: 'article',
      taglineItem_plural: 'articles',
      taglineItem_0: 'article',
      taglineItem_1: 'articles',
      taglineItem_2: 'articles'
    },
    collections: {
      taglineSaved: 'enregistré',
      createButtonText: 'Créer une nouvelle collection',
      loadErrorMessage: 'Impossible de charger les éléments suivants. Veuillez réessayer plus tard.',
      loadNext: 'Charger le suivant',
      // v4 plural
      tagline_one: 'collection',
      tagline_few: 'collections',
      tagline_many: 'collections',
      tagline_other: 'collections',
      // v3 plural
      tagline: 'collection',
      tagline_plural: 'collections',
      tagline_0: 'collection',
      tagline_1: 'collections',
      tagline_2: 'collections'
    },
    components: {
      myAccount: {
        details: {
          layoutTitle: '_TODO: My Account',
          layoutSubtitle: '_TODO: My Details',
          basicInfoSection: {
            title: '_TODO: Basic info',
            editButtonLabel: '_TODO: Click here to edit'
          }
        }
      },
      savedItem: {
        card: {
          ariaLabel: {
            save: 'Enregistrer',
            unsave: 'Désenregistrer'
          }
        }
      },
      searchFilter: {
        ariaLabel: {
          searchButton: 'recherche'
        },
        filteredResultsHeading: 'Résultats pour:',
        sr: {
          // v4 plural
          filteredItemsResults_one: 'résultat',
          filteredItemsResults_few: 'résultats',
          filteredItemsResults_many: 'résultats',
          filteredItemsResults_other: 'résultats',
          // v3 plural
          filteredItemsResults: 'résultat',
          filteredItemsResults_plural: 'résultats',
          filteredItemsResults_0: 'résultat',
          filteredItemsResults_1: 'résultats',
          filteredItemsResults_2: 'résultats'
        }
      }
    },
    hooks: {
      useResponseCodes: {
        firstName: {
          tooLong: '_TODO: First name must be no longer than 100 characters'
        },
        lastName: {
          tooLong: '_TODO: Last name must be no longer than 100 characters'
        },
        screenName: {
          notUnique: '_TODO: This screen name has already been taken',
          tooLong: '_TODO: Screen name must be no longer than 100 characters'
        },
        email: {
          invalid: '_TODO: Please enter a valid email address',
          notUnique: '_TODO: This email address has already been taken',
          tooLong: '_TODO: Email address must be no longer than 100 characters'
        }
      }
    },
    overview: {
      createButtonText: 'Créer une nouvelle collection',
      defaultTitle: 'Mon Hub',
      ugcButtonLabel: 'Voir plus',
      ugcCreateButtonText: 'Ajouter une recette'
    },
    ownItems: {
      createButtonText: 'Ajouter une nouvelle recette',
      loadErrorMessage: 'Impossible de charger les éléments suivants. Veuillez réessayer plus tard.',
      loadNext: 'Charger le suivant',
      tabData: {
        all: 'Tous',
        published: 'Publié',
        unpublished: 'Non publié'
      },
      tabFilterError: 'Il y a eu un problème pour filtrer vos recettes. Nous avons renvoyé toutes les recettes à la place.'
    },
    savedItems: {
      // v4 plural
      collectionTaglineItem_one: 'article',
      collectionTaglineItem_few: 'articles',
      collectionTaglineItem_many: 'articles',
      collectionTaglineItem_other: 'articles',
      // v3 plural
      collectionTaglineItem: 'article',
      collectionTaglineItem_plural: 'articles',
      collectionTaglineItem_0: 'article',
      collectionTaglineItem_1: 'articles',
      collectionTaglineItem_2: 'articles',
      collectionTaglineSaved: 'enregistré',
      loadErrorMessage: 'Impossible de charger les éléments suivants. Veuillez réessayer plus tard.',
      loadNext: 'Charger le suivant'
    }
  },
  nextCore: {
    signIn: {
      errorLineOne: 'Vous cherchez quelque chose de spécifique?',
      errorLineTwo: 'Essayez',
      errorLineThree: 'de vous connecter',
      errorLineFour: 'pour voir cette page.',
      errorLineFive: 'Vous n\'êtes pas encore inscrit pour votre compte gratuit?',
      errorLineSix: 'Rejoignez-nous ici'
    }
  },
  postCreator: {
    confirmation: {
      metaTitle: 'Créer une recette - Merci',
      newRecipeButtonText: 'Nouvelle recette',
      ownRecipeButtonText: 'Recettes personnelles'
    },
    create: {
      metaTitle: 'Créer une recette'
    },
    edit: {
      editFormTitle: 'Modifier la recette',
      metaTitle: 'Modifier la recette'
    },
    recipeDetails: {
      dropDownOptions: {
        hours: 'heures',
        mins: 'mins'
      },
      heading: 'Détails de la recette',
      label: {
        cookTime: 'Temps de cuisson (approx.)',
        difficulty: 'Niveau de difficulté',
        extraTime: 'Temps supplémentaire (facultatif)',
        image: 'Image',
        prepTime: 'Temps de préparation (approx.)',
        servings: 'Portions',
        shortIntro: 'Courte introduction (10-15 mots)',
        title: 'Titre de la recette (gardez-le court et descriptif)'
      },
      placeholder: {
        extraTime: 'par exemple plus de repos',
        makes: 'par exemple 8 pièces',
        serves: 'par exemple 4',
        shortIntro: 'Parlez-nous de votre recette',
        title: 'par exemple tarte aux pommes de maman'
      },
      servingsButton: {
        makes: 'Fait',
        serves: 'Sert'
      },
      skillLevel: {
        dropDownOptions: {
          challenge: 'Un défi',
          defaultText: '(Veuillez en sélectionner un)',
          easy: 'Facile',
          moreEffort: 'Plus d\'effort'
        }
      }
    },
    recipeForm: {
      defaultFeedback: {
        error: 'Oups! Quelque chose a mal tourné',
        info: 'Veuillez enregistrer votre image avant de soumettre'
      },
      links: {
        back: 'Retour à mes recettes',
        preview: 'Aperçu',
        saveDraft: 'Enregistrer le brouillon'
      }
    },
    recipeIngredients: {
      heading: 'Ingrédients',
      information: {
        lineOne: 'Veuillez utiliser le système métrique si possible (nous avons un',
        lineTwo: 'guide de conversion',
        lineThree: 'pour aider)',
        lineFour: 'Vous pouvez diviser vos ingrédients en groupes, par exemple sauce, garniture, etc.'
      },
      ingredient: {
        buttonText: 'Ajouter le prochain ingrédient',
        label: 'Ingrédient',
        placeholder: '500g de cuisses de poulet, coupées en dés'
      },
      ingredientGroup: {
        buttonText: 'Ajouter un titre de groupe',
        heading: 'Titre',
        placeholder: 'Pour la sauce'
      }
    },
    recipeMethodSteps: {
      heading: 'Méthode',
      method: {
        buttonText: 'Ajouter la prochaine étape',
        label: 'Étape',
        placeholder: 'Premièrement, faites bouillir le riz'
      }
    },
    statusFeedback: {
      createLinkeText: 'créer une nouvelle recette',
      info: {
        approved: 'Votre recette a été approuvée',
        "default": 'Oups, quelque chose a mal tourné',
        draft: 'Votre recette n\'a pas encore été soumise',
        pending: 'Votre recette est en attente d\'approbation',
        rejected: 'Votre recette n\'a pas été approuvée'
      },
      submissionChoice: {
        approved: 'voir votre recette',
        "default": 'retourner à votre hub de recettes',
        draft: 'continuer à modifier votre recette',
        heading: 'Peut-être aimeriez-vous'
      },
      submittedText: 'Votre recette a été soumise pour approbation et ne peut plus être mise à jour.'
    },
    submit: {
      formValidation: {
        defaultMessage: 'Veuillez confirmer que vous avez lu nos conditions générales'
      },
      informationLineOne: 'Veuillez noter que vous ne devez télécharger que vos propres recettes.',
      informationLineTwo: 'Pour des raisons de droits d\'auteur, nous ne pourrons pas publier de recettes téléchargées',
      informationLineThree: 'par nos utilisateurs qui ont été écrites à l\'origine par une autre source. Vous pouvez lire nos',
      informationLineFour: 'conditions générales',
      informationLineFive: 'pour plus d\'informations avant de soumettre votre recette.',
      metaTitle: 'Créer une recette - Conditions générales',
      previewButtonText: 'Aperçu',
      publishButtonText: 'Publier',
      termsLabel: 'Cochez pour confirmer que vous avez lu nos conditions générales'
    }
  }
};